<template>
  <div class="checkboxs-c1">
    <label class="checkboxqwe"  :style="{color: color}"
     :class="value&&value.includes(opt.value)?'selected':''" :key="o" v-for="(opt, o) in options" :for="opt.label">
      <input type="checkbox" :name="opt.label" :id="opt.label" :checked="value&&value.includes(opt.value)" @change="updateValue(opt.value)" :value="opt.value">{{opt.label}}</label>
  </div>

</template>

<script>
export default {
  props: ['options', 'defaultValue', 'color'],
  data () {
    return {
      value: []
    }
  },
  watch: {
    defaultValue () {
      this.value = this.defaultValue
    },
    value () {
      if (this.value !== this.defaultValue) {
        this.$emit('input', this.value)
      }
    }
  },
  mounted () {
    this.value = this.defaultValue
  },
  methods: {
    updateValue (opt) {
      console.log(opt, this.value)
      this.value = this.value.includes(opt) ? this.value.filter(e => e !== opt) : this.value.concat(opt)
    }
  }
}
</script>

<style lang="scss" scoped>
.checkboxs-c1 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  gap: 15px;
  flex-wrap: wrap;
}
label.checkboxqwe {
  height: 45px;
  min-width: 180px;
  white-space: nowrap;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  font-weight: 400;
  font-size: 20px;
  line-height: 150%;
  letter-spacing: 0.05em;
  color: var(--color-checked);
  &::before {
    content: '';
    width: 30px;
    height: 30px;
    display: inline-block;
    border: 1px solid var(--color-checked);
    border-radius: 5px;
  }
  &.selected::before {
    background-image: url(/svg/checkbox/checkmark.svg);
    background-position: center;
    background-size: 26px;
    background-repeat: no-repeat;
    background-color: var(--color-checked);

  }
}
input[type=checkbox] {
  display: none;
}
</style>
